import React, { useEffect, useState } from 'react';

const SecondaryMenu = () => {
  const [svgContents, setSvgContents] = useState({});
  const [activeItem, setActiveItem] = useState(null);
  const [promotionNotices, setPromotionNotices] = useState([]);
  const [promotionLoading, setPromotionLoading] = useState(false);
  const [promotionLoaded, setPromotionLoaded] = useState(false);
  const [promotionLoadingMore, setPromotionLoadingMore] = useState(false);
  const [promotionHasMore, setPromotionHasMore] = useState(true);
  const [promotionPage, setPromotionPage] = useState(0);
  const promotionPerPage = 8;
  
  const isPro = window.thhaAdminSettings?.is_pro_active;

  const SecondaryMenyItems = [
    { key: 'status', title: isPro ? 'pro' : 'free', icon: '', link: '#' },
    { key: 'help', title: 'Help', icon: 'help-circle', link: 'https://hugeaddons.com/' },
    { key: 'promotion', title: 'Promotion', icon: 'promotion', link: '#' },
    { key: 'user', title: 'User', icon: 'user-circle', link: '#' }
  ];

  useEffect(() => {
    if (activeItem !== null) {
        // console.log("New Active Item:", activeItem); 
    }
  }, [activeItem]);

  useEffect(() => {
    const handleDocumentClick = (event) => {
      if (!activeItem) return;
      if (activeItem !== 'status' && activeItem !== 'user') return;

      const isClickInside = event.target.closest(`.secondary-menu-item.${activeItem}`);
      if (!isClickInside) {
        setActiveItem(null);
      }
    };

    document.addEventListener('click', handleDocumentClick);
    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, [activeItem]);

  useEffect(() => {
    if (activeItem === 'promotion' && !promotionLoaded && !promotionLoading) {
      loadPromotionNotices({ reset: true });
    }
  }, [activeItem, promotionLoaded, promotionLoading]);
  
  // Load all SVGs (No change needed here)
  useEffect(() => {
    const loadSvgs = async () => {
      const svgData = {};
      
      for (const item of SecondaryMenyItems) {
        if (item.icon) {
          try {
            const response = await fetch(
              `${window.thhaAdminSettings.assets_url}img/${item.icon}.svg`
            );
            if (response.ok) {
              const svgText = await response.text();
              svgData[item.icon] = svgText;
            }
          } catch (error) {
            console.error(`Error loading SVG for ${item.icon}:`, error);
          }
        }
      }
      
      setSvgContents(svgData);
    };

    loadSvgs();
  }, []);

  const loadPromotionNotices = async ({ reset = false } = {}) => {
    if (reset) {
      setPromotionLoading(true);
    } else {
      if (promotionLoading || promotionLoadingMore || !promotionHasMore) {
        return;
      }
      setPromotionLoadingMore(true);
    }

    const nextPage = reset ? 1 : (promotionPage + 1);

    try {
      const payload = new URLSearchParams();
      payload.append('action', 'thha_get_promo_notices');
      payload.append('nonce', window.thhaAdminSettings?.nonce || '');
      payload.append('page', String(nextPage));
      payload.append('per_page', String(promotionPerPage));

      const response = await fetch(window.thhaAdminSettings.ajaxurl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        body: payload.toString()
      });

      const result = await response.json();
      if (result?.success && Array.isArray(result?.data?.notices)) {
        const fetchedNotices = result.data.notices;
        setPromotionNotices((prev) => (reset ? fetchedNotices : [...prev, ...fetchedNotices]));
        setPromotionPage(Number(result?.data?.page || nextPage));
        setPromotionHasMore(Boolean(result?.data?.has_more));
      } else {
        if (reset) {
          setPromotionNotices([]);
          setPromotionPage(1);
          setPromotionHasMore(false);
        }
      }
    } catch (error) {
      console.error('Error loading promotion notices:', error);
      if (reset) {
        setPromotionNotices([]);
        setPromotionPage(1);
        setPromotionHasMore(false);
      }
    } finally {
      setPromotionLoading(false);
      setPromotionLoadingMore(false);
      setPromotionLoaded(true);
    }
  };

  const handlePromotionScroll = (event) => {
    const container = event.currentTarget;
    const reachedBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 40;

    if (reachedBottom) {
      loadPromotionNotices();
    }
  };

  const handleItemClick = (itemKey, event) => {
    if (event?.target?.closest('.status-menu-item, .user-menu-item')) {
      return;
    }

    if(activeItem !== itemKey){
      setActiveItem(itemKey);
    }else{
      setActiveItem(null);
    }
  };

  const handleClosePromotion = () => {
    if (activeItem === 'promotion') {
      setActiveItem(null);
    }
  };

  return (
    <>
      <div className="secondary-menu">
        <ul className="secondary-menu-list">
          {SecondaryMenyItems.map((item) => (
            <li 
              key={item.key} 
              className={`secondary-menu-item ${item.link ? 'has-link' : ''} ${item.icon ? 'has-icon' : ''} ${item.key} ${activeItem === item.key ? 'active' : ''}`}
              onClick={(event) => handleItemClick(item.key, event)}
            >
              {item.icon ? (
                <span className={`icon ${item.icon}`} dangerouslySetInnerHTML={{ __html: svgContents[item.icon] }} /> 
              ) : (
                <span>{item.title}</span>
              )}
              
              { item.key === 'status' && activeItem === 'status' && window.thhaAdminSettings.version ?(
                <div className="status-menu-item">
                  <div className="version">Version</div>
                  <div className="details">
                    <div className="ver-number">{isPro ? window.thhaAdminSettings.pro_version : window.thhaAdminSettings.version}</div>
                    <div className="system">{isPro ? 'pro' : 'core'}</div>
                  </div>
                </div>
              ): null}
              
              { item.key === 'user' && activeItem === 'user' && window.thhaAdminSettings.version ?(
                <div className="user-menu-item">
                  <div className="details row">
                    <div className="license-status">License Status</div>
                    <div className="license-type">{isPro ? 'active' : 'inactive'}</div>
                  </div>
                  <div className="details row">
                    <div className="license-status">Manage Plan</div>
                    <a href="https://hugeaddons.com/" target="_blank" className="link externel"><i className='thha-icon thha-icon-externel-link w12'></i></a>
                  </div>
                </div>
              ): null}
            </li>
          ))}
        </ul>
      </div>

      <div
        className={`promotion-offcanvas-backdrop ${activeItem === 'promotion' ? 'is-open' : ''}`}
        onClick={handleClosePromotion}
      ></div>

      <aside className={`promotion-offcanvas ${activeItem === 'promotion' ? 'is-open' : ''}`}>
        <div className="promotion-offcanvas-header">
          <div className="promotion-heading">Promotional Notices</div>
          <button type="button" className="promotion-close" onClick={handleClosePromotion}>
            &times;
          </button>
        </div>

        {promotionLoading ? (
          <div className="promotion-empty">Loading notices...</div>
        ) : null}

        {!promotionLoading && promotionNotices.length === 0 ? (
          <div className="promotion-empty">No promotional notices available.</div>
        ) : null}

        {!promotionLoading && promotionNotices.length > 0 ? (
          <div className="promotion-list" onScroll={handlePromotionScroll}>
            {promotionNotices.map((notice) => (
              <div className={`promotion-notice ${notice.type || 'info'}`} key={notice.unique_id}>
                {notice.title ? <div className="promotion-title">{notice.title}</div> : null}
                <div className="promotion-message" dangerouslySetInnerHTML={{ __html: notice.message }} />
                {notice.link_url && notice.link_label ? (
                  <a className="promotion-link" href={notice.link_url} target="_blank" rel="noreferrer">
                    {notice.link_label}
                  </a>
                ) : null}
              </div>
            ))}

            {promotionLoadingMore ? (
              <div className="promotion-loader" aria-live="polite" aria-label="Loading more notices">
                <span className="spinner" aria-hidden="true"></span>
                <span className="loader-text">Loading more notices...</span>
              </div>
            ) : null}

            {!promotionLoadingMore && !promotionHasMore ? (
              <div className="promotion-empty">You reached the end.</div>
            ) : null}
          </div>
        ) : null}
      </aside>

    </>
  );
};

export default SecondaryMenu;